module.exports = __webpack_public_path__ + "img/hr-wooden-particle-shadow-25.89997f57.png";